<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>三维影像后处理系统</h1>
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 文字描述区域 -->
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
            <p class="text-content">{{ p[1] }}</p>
          </div>

          <!-- 顶部图片缩略组件 -->
          <ImgCol :imgList="img.slice(0,3)"></ImgCol>

          <!-- 功能分类卡片组件 -->
          <CardBorder :h6="h6" :msg="p.slice(2)" :img="img.slice(3)"></CardBorder>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgCol from "@/components/imgCol.vue"
import CardBorder from "./cardBorder.vue"
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
        hidePullDown: {
            type: Boolean,
            default: false // 默认显示
        }
    },
  name: "Image3DHandle",
  components: {
    ImgCol,
    CardBorder,
    PullDown
  },
  data() {
    return {
      wWidth: window.innerWidth,
      p: [
        "三维医学影像后处理是根据分析输入的断层图像序列，经分割和提取后，构建出待建组织的三维几何模型。医学影像的三维后处理将一系列二维图像重建出三维图像模型，为医生提供真实感的三维医学图像，提高诊断的正确率。",
        "本产品包含功能全面、实用的三维基础分析模块，同时可选配功能强大、智能化的三维高级模块。",
        "针对血管疾病的专业可视化检测分析平台，精准测量、定位 定性，量化分析报告生成。",
        "综合性心脏冠脉测量分析利器集疾病筛查、特性分析、治疗方案指导于一体。",
        "肺部结节精准智能检测 诊断不再“雾里看花”结节检出率高 精准随访对比。",
        "强大的肺部密度评估系统，快速显现气肿分布与扩散，肺密度重建与评估分析。",
        "针对结肠疾病特性分析与诊断治疗的专业工具，支持路径规划导航与自动检测，全视角观察结肠内壁。"
      ],
      img: [
        require("@/assets/handle0.png"),
        require("@/assets/handle1.png"),
        require("@/assets/handle2.png"),
        [require('@/assets/HList1.png'), require('@/assets/HList2.png')],
        [require('@/assets/HList3.png'), require('@/assets/HList4.png')],
        [require('@/assets/HList5.png'), require('@/assets/HList6.png')],
        [require('@/assets/HList7.png'), require('@/assets/HList8.png')],
        [require('@/assets/HList9.png'), require('@/assets/HList10.png')],
      ],
      h6: ['血管分析', '心脏分析', '肺结节AI分析', '肺气肿分析', '结肠分析'],
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一标准文字样式（全系列页面共用）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // ImgCol 全局穿透样式统一
  :deep(.imgCom) {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    margin-bottom: 14px;
  }
  :deep(.imgCom:hover) {
    transform: translateY(-3px);
    box-shadow: 0 10px 26px rgba(10, 40, 70, 0.12);
  }
  :deep(.imgCom img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
    loading: lazy;
  }
  :deep(.imgCom:hover img) {
    transform: scale(1.04);
  }
}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        :deep(.imgCom) {
          background: #142033;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>